import React, { useContext,useEffect } from 'react'
import {dataContext,toText,localestr,loaddat} from '../utils.js'
import UniTable from '../cmp/UniTable.js'
import FilterForm from '../cmp/FilterForm.js' //+
import Menu from '../cmp/menu.js'
import icon from '../icons.svg'

function CatCertificatesList({data=undefined,actions,choice=false}){
    const type='catCertificates'
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabNew=actions.tabNew
    const tabClose=actions.tabClose
    const tabChoice=actions.tabChoice
    const tblPos=actions.tblPos  //Таблиця
    const isActive=actions.isActive  //Таблиця
    const setGlData=actions.setGlData
    const getGlData=actions.getGlData

    const context=useContext(dataContext)
    const Data=context.data[type]
    const getData=context.getData
    const saveData=context.saveData
    const updateData=context.updateData
    const msg=context.msg
    const inputCols=context.inputCols
    const setSettings=context.setSettings
    const getSettings=context.getSettings
    const usersettings=getSettings()
    const setLoginData=context.setLoginData
    const glStatus=context.status
    let balance=undefined
    if(wndData) balance=wndData.balance
    let hiden=true
    if(wndData.hiden!==undefined) hiden=wndData.hiden
    const setHiden=d=>setWndData({...wndData,hiden:d})
    const sysConst=context.data['sysConst']

    const cols=[
        {caption:'icon',minWidth:'24',dataId:'catCert',sortable:false},
        {caption:'id',minWidth:'12',dataId:'id',sortable:true},
        {caption:localestr('Код'),minWidth:'160',dataId:'code',sortable:true},
        {caption:localestr('Дійсний з'),minWidth:'90',dataId:'start',sortable:true},
        {caption:localestr('по'),minWidth:'90',dataId:'finish',sortable:true},
        {caption:localestr('Баланс'),minWidth:'90',dataId:'sum_bal',sortable:true},
   ]

   if(usersettings.CatCertificatesList&&usersettings.CatCertificatesList.cols){
        for(let i=0;i<usersettings.CatCertificatesList.cols.length;i++){
            const idx=cols.findIndex(el=>el.dataId===usersettings.CatCertificatesList.cols[i])
            if(idx!==-1) cols[idx].hiden=true
        }
    }

    const filterData=[ //+
        {caption:localestr('Код'),dataId:'code',typeVal:'text'},
        {caption:localestr('Дійсний з'),dataId:'start',typeVal:'date'},
        {caption:localestr('Дійсний по'),dataId:'finish',typeVal:'date'},
    ]

    const setFilter=(id,val,type)=>{
        let filter=[...(wndData.filter||[])]
        const idx=filter.findIndex(el=>el.dataId===id)
        if(idx!==-1){
            if(!val) filter.splice(idx,1)
            else filter[idx].value=val
        } else if(val) filter.push({dataId:id, compare:'lk', value:val, typeVal:type})
        if (!filter.length) filter=undefined
        setWndData({...wndData,filter,currentCol:undefined})
        setGlData({needFocus:1})
        tblPos(0)
    }

    const showHideFilter=()=>{
        const showAFilter=!wndData.showAFilter
        if(!showAFilter) setWndData({...wndData,filter:undefined,showAFilter})
        else setWndData({...wndData,showAFilter})
    }

    const listFromData=(currentCol,setCurrCol)=>{
        let list=[]
        let balance=[]
        if(wndData.balance) balance=wndData.balance
        /*let dis=[]
        const curDate=new Date()
        if (typeof Irg !== 'undefined') dis=Irg.map(item=>{return({...item,date:new Date(item.date)})})
        if (typeof Data !== 'undefined') list=Data.map((item)=>{
            let prc=dis.filter(el=>el.id===item.id&&el.date<curDate).reduce((acc,el)=>{return acc.date>el.date?acc:el})
            if(prc) prc=prc.value
            const newItem={...item,prc:prc||''}
            if (typeof currentCol !== 'undefined' && currentCol.id===item.id) setCurrCol(newItem)
            return newItem})*/
        if (typeof Data !== 'undefined') list=Data.map((item)=>{
            const newItem={...item}
            const idx=balance.findIndex(x => x.cert === parseInt(item.id))
            if(idx!==-1) newItem.sum_bal=balance[idx].sum===0?'':balance[idx].sum.toFixed(2)
            if (typeof currentCol !== 'undefined' && currentCol.id===item.id) setCurrCol(newItem)
            return newItem})
        return list
    }

    const sortList=(col,sort,list)=>{
        let needUpd=false
        let currentCol=wndData.currentCol
        if (typeof list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else if (typeof wndData.list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else list=wndData.list.slice()

        list.sort((a,b)=>{
            let vala=toText(a[col])
            let valb=toText(b[col])
            if(col==='id'){
                vala=parseInt(vala)
                valb=parseInt(valb)
            } else if(col==='prc') {
                vala=parseFloat(vala)
                valb=parseFloat(valb)
            } else {
                vala=vala.toLowerCase()
                valb=valb.toLowerCase()
            }
            if (sort==='asc') {
                if (vala < valb) {needUpd=true;return -1}
                if (vala > valb) return 1
                return 0
            } else if (sort==='desc'){
                if (vala < valb) return 1
                if (vala > valb) {needUpd=true;return -1}
                return 0
            } else return 0
        })
        const sorting={dataId:col,sort:sort}
        if (needUpd || wndData.sorting.dataId!==col || wndData.sorting.sort!==sort) 
        setWndData({...wndData,list,sorting,currentCol})
    }

    const setHidenCols=(data)=>{
        if(data){
            const new_data=data.filter(el=>el.hiden).map(el=>el.dataId)
            setSettings({CatCertificatesList:{cols:new_data}})
        } else {
            inputCols(cols,setHidenCols)
        }
    }

    const newItem=()=>{
        tabNew('catCertificates_edit',localestr('Сертифікат')+' *',{start:(new Date()).toISOString().substring(0,10),changed:true,author:context.user,account:{id:sysConst.constCashbox},payType:'0'})
    }

    const editItem=(d)=>{
    if (!wndData.currentCol) return
    if(d) {
        const status=d.status
        if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
        if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
        tabNew('catCertificates_edit',localestr('Сертифікат')+' '+toText(wndData.currentCol['name']),{...wndData.currentCol,docs:d.data})
    }
    else loaddat('action=docCerts&data='+wndData.currentCol['id'],editItem)
    }

    const editClick=()=>{
        if (typeof wndData.currentCol === 'object') {
            if(choice) {tabChoice(wndData.currentCol);tabClose()}
            else editItem()
        }
    }
            
    const getNextItem=(i,d)=>{
        if(d>0) for(let idx=i+1;idx<wndData.list.length;idx++) if(!parseInt(wndData.list[idx].marked)&&wndData.list[idx].parent.id===wndData.currentFld.id) return ({...wndData.list[idx]})
        else for(let idx=i-1;idx>=0;idx--) if(!parseInt(wndData.list[idx].marked)&&wndData.list[idx].parent.id===wndData.currentFld.id) return ({...wndData.list[idx]})

        return undefined
    }

    const removeItem=()=>{
        if (typeof wndData.currentCol === 'object') {
            const idx=wndData.list.findIndex(el=>el.id===wndData.currentCol.id)
            let item=undefined
            if(hiden&&idx+1>=wndData.list.length&&idx>0) item=getNextItem(idx,-1)
            else if(hiden&&idx>0) item=getNextItem(idx,1)
            else if(idx!==-1) item={...wndData.list[idx]}
            let newData={status:'rem',key:type,data:{id:wndData.currentCol.id,marked:(wndData.currentCol.marked==='1'?'0':'1')}}
            saveData(newData,()=>{setWndData({...wndData,currentCol:item})})
        }
    }

    
    
    const setCol=(currentCol)=>{
        //const list=wndData.list
        //const sorting=wndData.sorting
        setWndData({...wndData,currentCol})
        setGlData({needFocus:0})
    }

    const filter=(fltr)=>{
        let showFilter=!wndData.showFilter
        let filter=wndData.filter
        if (fltr!==undefined) filter=fltr
        if(showFilter || fltr===undefined) setWndData({...wndData,showFilter,filter})
        else{
            setWndData({...wndData,showFilter,filter,currentCol:undefined})
            setGlData({needFocus:1})
            tblPos(0)
        }
    }

    const copyItem=()=>{
        if (typeof wndData.currentCol === 'object') {
            let item={...wndData.currentCol}
            delete item.id
            tabNew('catCertificates_edit',localestr('Сертифікат')+' *',item)
        }
    }

    const clrCatalog=(noQuestions)=>{
        if(noQuestions){
            let newData={status:'clr',key:type}
            saveData(newData,()=>{})
        }
        else msg(localestr('Буде видалено позначені елементи без\nможливості відновлення! Продовжити?'),localestr('Попередження'),[{caption:'OK',action:()=>{clrCatalog(true)}},{caption:localestr('Відміна'),action:()=>{}}])
    }
        
    const objHistory=()=>{
        if (typeof wndData.currentCol === 'object') {
            tabNew('repObjHistory',localestr('Історія змін')+' '+toText(wndData.currentCol['name']),{object:{...wndData.currentCol,type:type}},true)
        }
    }
        
    const anyKey=(key)=>{
        if(key==='Delete') removeItem()
        else if(key==='Insert') newItem()
        else if(key==='F9') copyItem()
        //else if(key==='Escape') cancelEdit()
        else if(key==='shift_F4') tabClose()
        else if(key==='F2') filter()
        //else console.log(key)
    }

    const loadData=(d)=>{
        if (d) {
            const status=d.status
            if(status==='UsrChoise') {setLoginData(d);return}
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            wndData=actions.getWndData()
            setWndData({...wndData,balance:d.data})
        } else {
            loaddat('action=balCerts',(dt)=>{loadData(dt)})
        }
    }

    const tick=()=>{
        if (wndData.showFilter) return
        loadData()
    }

    
    const needFocus=(reset=true)=>{   //Таблиця
        if(isActive()===false) return -1
        const glData=getGlData()
        const needFocus=glData.needFocus
        if(needFocus===undefined) return -1
        if(reset) setGlData({needFocus:-1})
        return needFocus
    }

    useEffect(() => {
        if(glStatus==='loading') return
        if(glStatus==='UsrChoise') return
        if (typeof Data === 'undefined') getData(type)
        else if (wndData && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('name','asc',undefined)
    // eslint-disable-next-line 
    },[Data,balance])

    useEffect(() => {
        if(glStatus==='loading') return
        if(glStatus==='UsrChoise') return
        tick()
        const intervalHandle=setInterval(tick,30000)
        return () => clearInterval(intervalHandle)
    // eslint-disable-next-line 
    },[])


    let wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
    if(hiden) wndDataList=wndDataList.filter(item=>!parseInt(item.marked))
    const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
    const showFilter = wndData.showFilter ? <FilterForm filterData={filterData} filter={wndData.filter} setFilter={filter}/> : ''  //+

    const menuData=[
        {name:localestr('Налаштування таблиці'),icon:'#b953',action:setHidenCols},
        {name:localestr('Автофільтр'),icon:'#b955',action:showHideFilter},
        {name:localestr('Друк списку'),icon:'#b503',action:()=>{window.print()}},
        {name:localestr('Історія змін'),icon:'#hisBut',action:objHistory},
        {name:localestr('Остаточне видалення'),icon:'#remBut',action:clrCatalog},
        {name:localestr('Оновити список'),icon:'#b954',action:()=>{updateData(type)}},
    ]
    if(hiden) menuData.push({name:localestr('Показати видалені'),icon:'#remBut',action:()=>setHiden(false)})
    if(!hiden) menuData.push({name:localestr('Сховати видалені'),icon:'#remBut',action:()=>setHiden(true)})
    if(choice) menuData.splice(2,3)

    return(
        <>
        <div style={{display:'flex',flexDirection:'column',height:'calc(100% - 3px)',width:'100%'}}>
        <div className='toolBar no-print'>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Додати')+' (Ins)'} 
            onClick={()=>{newItem()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') newItem()}}><img src={icon+'#addBut'} alt={localestr('Додати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Редагувати')} 
            onClick={()=>{editItem()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') editItem()}}><img src={icon+'#editBut'} alt={localestr('Редагувати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Копіювати')+' (F9)'} 
            onClick={copyItem} onKeyUp={(e)=>{if(e.key === 'Enter') copyItem()}}
            ><img src={icon+'#copyBut'} alt={localestr('Копіювати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Видалити')+' (Del)'}
            onClick={()=>{removeItem()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') removeItem()}}><img src={icon+'#delBut'} alt={localestr('Видалити')} /></div>
            <div  tabIndex='0' className='toolBarSeparator'></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Фільтр')}  
            onClick={()=>{filter()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') filter()}}><img src={icon+'#filtBut'} alt={localestr('Фільтр')} /></div>
            <div style={{flexGrow:'10'}}></div>
            <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
                <img className='toolBarIcon' src={icon+'#dnBut'} alt='' />
            </Menu></div>
        </div>
        <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={wndData.currentCol} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} clickSort={sortList} clickHandle={(item)=>{setCol(item)}} openHandle={editClick} keyHandle={anyKey} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus}/>
        </div>
        {showFilter}
        </>
    )
    
}

export default CatCertificatesList